export default __webpack_public_path__ + "static/media/news-six2.ea5d9c7f.jpg";